module.exports = __webpack_public_path__ + "static/media/rag_horizontal.16b71fa1.mp4";